import { css } from '@emotion/css';

export const imageBorderStyles = ({ size }: { size: string }) => css`
  &:after {
    content: '';
    position: absolute;
    inset: 0px;
    border: ${size} solid var(--border);
    border-radius: inherit;
    opacity: 0.6;
    mix-blend-mode: multiply;
  }
`;
